import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ToggleSwitch (props) {
  const className = classNames('toggle-switch-control', {
    'toggle-switch-on': props.enabled,
    'toggle-switch-off': !props.enabled
  });

  return (
    <div className={className}>
      <span className='label off' onClick={() => props.enabled && props.onToggle(false)}>{props.labelOff}</span>
      <span className='tumbler' onClick={() => props.onToggle(!props.enabled)} />
      <span className='label on' onClick={() => !props.enabled && props.onToggle(true)}>{props.labelOn}</span>
    </div>
  );
}

ToggleSwitch.propTypes = {
  enabled: PropTypes.bool,
  labelOff: PropTypes.string.isRequired,
  labelOn: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired
};
ToggleSwitch.defaultProps = {
  enabled: false
};

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/ui/Controls/ToggleSwitch.jsx